import { AlertCircle } from 'lucide-react';

/** Page-level error banner (red alert box shown directly under the page header).
 *
 * Extracted verbatim from DistributionListsPage / MailerSetupPage, where this exact
 * markup sat below `</header>` inside an `{error && (...)}` guard. Distinct from
 * <FormErrorBanner/> (which uses different padding/colours for modal forms): this one
 * keeps the page-banner classes (`px-4 py-3`, `text-red-800`, `<span>`) so output is
 * identical. Callers keep their own `{error && (...)}` guard and pass the message in. */
export function PageErrorBanner({ message }: { message: string }) {
  return (
    <div className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
      <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
}
